export default __webpack_public_path__ + "static/window-42767b88ad6e89dc82136168c564a970.png";